window.console.log('%c' + theme_object.messages.realisation_by, 'background: #191919; padding: 10px; color: #ffffff');

//document.addEventListener('DOMContentLoaded', function () {

    setTimeout(function () {
        document.body.classList.remove('notransition');
        document.querySelectorAll('.gform_wrapper').forEach(function (form) {
            form.style.display = ''; // Removes inline display: none
        });
    }, 100);    
//});